<template>
  <CimsNeoTable
    ref="table"
    :columns="columns"
    :data="data"
    :pagination="pagination"
    show-total
    :no-data-text="noDataText"
    :showColMenu="showColMenu"
    menuIcon=""
    menuBtnIcon="md-more"
    :uid="`${uid}_${mixin_uid}`"
    v-on="$listeners"
    v-bind="$attrs"
  >
    <template slot-scope="{ row, column, index }" v-for="col in slots" :slot="col.slot">
      <slot :row="row" :column="column" :index="index" :name="col.slot"></slot>
    </template>
    <template slot-scope="{ row }" slot="Radio">
      <Radio v-model="row.ischecked" @on-change="radioOnChange(row)"></Radio>
    </template>
  </CimsNeoTable>
</template>
<script>
  import CimsNeoTable from 'cims-neo-table';
  import { mixin } from '@/mixins';

  export default {
    name: 'NeoTable',
    components: {
      CimsNeoTable,
    },
    mixins: [mixin],
    props: {
      columns: {
        type: Array,
        default: [],
      },
      data: [Array, Function],
      uid: {
        type: String,
        default: '',
      },
      pagination: {
        type: Boolean,
        default: true,
      },
      noDataText: {
        type: String,
        default() {
          return this.$t('columns.noDataText');
        },
      },
      itemKey: {
        type: String,
        default: '',
      },
      showColMenu: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      slots: function () {
        return this.columns.filter(col => col.slot);
      },
    },
    methods: {
      radioOnChange(row) {
        const key = this.itemKey;
        this.$refs.table.data1.forEach(item => {
          this.$set(item, 'ischecked', item[key] === row[key]);
        });
      },
      getSelection() {
        return this.$refs.table.data1.find(item => item.ischecked);
      },
    },
  };
</script>
